export enum OrderStatusForRetestEnum {
    AVAILABLE = 0,
    ORDER_NOT_COMPLETED,
    RETEST_WINDOW_EXPIRED,
    ONGOING_RETESTS,
    ORDER_CANCELLED,
}
